<div>
  <a [ngClass]="data.mainType" class="btn mr-2">{{ data.mainTitle }}</a>
  <a class="btn btn-link">{{ data.additionalTitle }}</a>
</div>